import { createApi } from "@reduxjs/toolkit/query/react";
import { CreateDeployListFile } from "@shared/models";
import { axiosBaseQuery } from "@shared/utils/request";

import config from "../../../config";

export const investorFileApi = createApi({
  reducerPath: "investorFileApi",
  baseQuery: axiosBaseQuery({
    baseUrl: `${config.baseApiUrl}`,
  }),
  tagTypes: ["InvestorFiles"],
  endpoints: (builder) => ({
    createFile: builder.mutation<void, CreateDeployListFile>({
      query: (body) => ({
        url: "investor-files",
        method: "POST",
        body,
      }),
    }),
  }),
});

export const { useCreateFileMutation } = investorFileApi;
